var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row mb-2" }, [
    _c(
      "div",
      { staticClass: "col-lg-2 col-md-4" },
      [
        _c("label", { attrs: { for: "sprint" } }, [_vm._v("Sprint")]),
        _vm._v(" "),
        _c("dropdown", {
          attrs: {
            name: "sprint",
            disabled: _vm.loading,
            datasource: _vm.filters,
            placeholder: _vm.resource(
              "SprintPlanning_Filter_Sprint_Placeholder"
            )
          },
          on: {
            input: function($event) {
              return _vm.$emit("filter-changed", $event)
            }
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "col-lg-1 col-md-2 d-flex flex-column" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-outline-secondary mt-auto",
          attrs: { disabled: _vm.loading },
          on: {
            click: function($event) {
              return _vm.$emit("refresh")
            }
          }
        },
        [
          _c("i", { staticClass: "fas fa-sync" }),
          _vm._v(" " + _vm._s(_vm.resource("Button_Refresh")) + "\n        ")
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }